import { createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./authThunks";

const API_BASE = process.env.REACT_APP_API_BASE;
const API_KEY = process.env.REACT_APP_API_KEY;

/**
 * fetch all Vendorrecommendations entries
 */
export const fetchVendorrecommendationsItems = createAsyncThunk(
  "vendorrecommendations/fetchItems",
  async (_, thunkAPI) => {
    const res = await fetch(`${API_BASE}/api/vendorrecommendations`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": API_KEY,
      },
    });
    // if (res.status === 401) {
    //   thunkAPI.dispatch(logoutUser());
    //   window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
    //   return thunkAPI.rejectWithValue("Unauthorized");
    // }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

// POST a new vendor recommendation
export const postVendorrecommendation = createAsyncThunk(
  "vendorrecommendations/postItem",
  async (data, thunkAPI, { rejectWithValue }) => {
    try {
      const res = await fetch(`${API_BASE}/api/vendorrecommendations`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": API_KEY,
        },
        body: JSON.stringify(data),
      });
      // if (res.status === 401) {
      //   thunkAPI.dispatch(logoutUser());
      //   window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      //   return thunkAPI.rejectWithValue("Unauthorized");
      // }
      const json = await res.json();

      if (!res.ok) {
        return rejectWithValue(
          json?.message || "Failed to submit recommendation"
        );
      }

      return json;
    } catch (error) {
      return rejectWithValue(error.message || "Unexpected error");
    }
  }
);
